"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var initialReadWriteRecipientWellStore = {
    pendingFindPeopleRequests: 0,
};
var store = satcheljs_1.createStore('readwriterecipientwell', initialReadWriteRecipientWellStore)();
exports.default = store;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/store/store.js
// module id = 2821
// module chunks = 2 3 4 45